export * from 'SourceType/Account.type';

export const MY_ACCOUNT = 'profile';
export const MY_BITCASH = 'my-bitcash';
export const MY_SUBSCRIPTION = 'my-subscription';
export const MY_SAVED_CARD = 'my-saved-card';
